import { SimulationProvider } from './contexts/SimulationContext';
import Simulator from './components/Simulation/Simulator';
import { ErrorBoundary } from '@sentry/react';
import ErrorFallback from './components/Error/ErrorFallback';
import { ReferralNotificationDrawer } from './components/Notifications/ReferralNotificationDrawer';

const App: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <SimulationProvider>
        <Simulator />
        <ReferralNotificationDrawer />
      </SimulationProvider>
    </ErrorBoundary>
  );
};

export default App;
